import { render, staticRenderFns } from "./pwa_double_currency_tab.vue?vue&type=template&id=0a399e74&scoped=true&"
import script from "./pwa_double_currency_tab.vue?vue&type=script&lang=js&"
export * from "./pwa_double_currency_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a399e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a399e74')) {
      api.createRecord('0a399e74', component.options)
    } else {
      api.reload('0a399e74', component.options)
    }
    module.hot.accept("./pwa_double_currency_tab.vue?vue&type=template&id=0a399e74&scoped=true&", function () {
      api.rerender('0a399e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/double_currency/pwa_double_currency_tab.vue"
export default component.exports